import { DefaultService } from '@/services/DefaultService';

export default class FunilService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    save(funil) {
        return this._http.post(`${this._env}/ven/funil`, funil, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacao(funil) {
        return this._http.post(`${this._env}/ven/funil/updatesituacao`, funil, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    find(id) {
        return this._http.get(`${this._env}/ven/funil/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    delete(id) {
        return this._http.delete(`${this._env}/ven/funil/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAll(column = 'descricao', order = 'asc', page = 0, limit = 50, situacao = 2, ...params) {
        return this._http.get(encodeURI(`${this._env}/ven/funil.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAllCombo(situacao = 1, ...params) {
		return this._http.get(encodeURI(`${this._env}/ven/funil/getcombo.json?param=${params}&situacao=${situacao}`), this._headers).then(res => {
				return res.body;
		}, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
		});
	}
}